import { gql } from "@apollo/client";

import { EVENT_WITH_RELATIONS_FRAGMENT } from "./fragments/eventWithRelations";
import { EVENT_OCCURRENCE_WITH_RELATIONS_FRAGMENT } from "./fragments/eventOccurrenceWithRelations";

export const GET_EVENTS = gql`
  ${EVENT_WITH_RELATIONS_FRAGMENT}
  query GetEvents(
    $take: Int
    $skip: Int
    $filters: EventFilterInput
    $orderBy: [EventOrderByInput!]
    $venueInclude: Boolean = false
    $imageInclude: Boolean = false
    $seatMapInclude: Boolean = false
    $ticketPoolsInclude: Boolean = false
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $presalePasswordsInclude: Boolean = false
    $presalePasswordsSkip: Int
    $presalePasswordsTake: Int
    $presalePasswordsFilters: PresalePasswordFilterInput
    $presalePasswordsOrderBy: [PresalePasswordOrderByInput!]
    $discountCodesInclude: Boolean = false
    $discountCodesSkip: Int
    $discountCodesTake: Int
    $discountCodesFilters: DiscountCodeFilterInput
    $discountCodesOrderBy: [DiscountCodeOrderByInput!]
    $includePreviewId: Boolean = false
  ) {
    events(take: $take, skip: $skip, filters: $filters, orderBy: $orderBy) {
      count
      nodes {
        ...EventWithRelations
      }
    }
  }
`;

export const GET_EVENT = gql`
  ${EVENT_WITH_RELATIONS_FRAGMENT}
  query GetEvent(
    $id: Int!
    $venueInclude: Boolean = false
    $imageInclude: Boolean = false
    $seatMapInclude: Boolean = false
    $ticketPoolsInclude: Boolean = false
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $presalePasswordsInclude: Boolean = false
    $presalePasswordsSkip: Int
    $presalePasswordsTake: Int
    $presalePasswordsFilters: PresalePasswordFilterInput
    $presalePasswordsOrderBy: [PresalePasswordOrderByInput!]
    $discountCodesInclude: Boolean = false
    $discountCodesSkip: Int
    $discountCodesTake: Int
    $discountCodesFilters: DiscountCodeFilterInput
    $discountCodesOrderBy: [DiscountCodeOrderByInput!]
    $includePreviewId: Boolean = false
  ) {
    event(id: $id) {
      ...EventWithRelations
    }
  }
`;

export const GET_EVENT_OCCURRENCES = gql`
  ${EVENT_OCCURRENCE_WITH_RELATIONS_FRAGMENT}
  query GetEventOccurrences(
    $start: AWSDateTime!
    $end: AWSDateTime!
    $filters: EventOccurrenceFilterInput
    $eventInclude: Boolean = false
    $ticketsAggregationInclude: Boolean = false
    $venueInclude: Boolean = false
    $imageInclude: Boolean = false
    $seatMapInclude: Boolean = false
    $ticketPoolsInclude: Boolean = false
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $presalePasswordsInclude: Boolean = false
    $presalePasswordsSkip: Int
    $presalePasswordsTake: Int
    $presalePasswordsFilters: PresalePasswordFilterInput
    $presalePasswordsOrderBy: [PresalePasswordOrderByInput!]
    $discountCodesInclude: Boolean = false
    $discountCodesSkip: Int
    $discountCodesTake: Int
    $discountCodesFilters: DiscountCodeFilterInput
    $discountCodesOrderBy: [DiscountCodeOrderByInput!]
    $includePreviewId: Boolean = false
  ) {
    eventOccurrences(start: $start, end: $end, filters: $filters) {
      nodes {
        ...EventOccurrenceWithRelations
      }
    }
  }
`;

export const GET_EVENT_OCCURRENCE = gql`
  ${EVENT_OCCURRENCE_WITH_RELATIONS_FRAGMENT}
  query GetEventOccurrence(
    $id: String!
    $eventInclude: Boolean = false
    $ticketsAggregationInclude: Boolean = false
    $venueInclude: Boolean = false
    $imageInclude: Boolean = false
    $seatMapInclude: Boolean = false
    $ticketPoolsInclude: Boolean = false
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $presalePasswordsInclude: Boolean = false
    $presalePasswordsSkip: Int
    $presalePasswordsTake: Int
    $presalePasswordsFilters: PresalePasswordFilterInput
    $presalePasswordsOrderBy: [PresalePasswordOrderByInput!]
    $discountCodesInclude: Boolean = false
    $discountCodesSkip: Int
    $discountCodesTake: Int
    $discountCodesFilters: DiscountCodeFilterInput
    $discountCodesOrderBy: [DiscountCodeOrderByInput!]
    $includePreviewId: Boolean = false
    $isPreview: Boolean = false
  ) {
    eventOccurrence(id: $id, isPreview: $isPreview) {
      ...EventOccurrenceWithRelations
    }
  }
`;
